<template>
  <div>
    <form class="login" @submit.prevent="login">
      <h1>Einloggen</h1>
      <label>Username</label>
      <input required v-model="username" type="text" placeholder="2-3 Zeichen" />
      <label>Passwort</label>
      <input
        required
        v-model="password"
        type="password"
        placeholder="***********"
      />
      <hr />
      <button type="submit">Einloggen</button>
      <router-link  class="mt-4" to="/forgotPassword">Passwort vergessen?</router-link>

    </form>
  </div>
</template>

<style>
.login {
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 10px;
}
</style>

<script>
import { AUTH_REQUEST } from "actions/auth";

export default {
  name: "login",
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    login: function() {
      const { username, password } = this;
      this.$store.dispatch(AUTH_REQUEST, { username, password }).then(() => {
        this.$router.push("/hours");
      }).catch((res) => {
        alert("Fehler: " + res.response.data.message);
      });
    }
  }
};
</script>
